import React from "react";
import styled from "styled-components";
import { Box } from "../Box";
import { SkeletonMask } from "../__Internal__";
import { style } from "../style";
import { VPCNote } from "./VPCNote";

const Container = styled.div`
  all: unset;
  font-size: ${style.vars.fontSize.base};
  line-height: 1;
`;

type Props = {
  "data-testid"?: string;
};

export const VPCSkeleton: React.FC<Props> = (props) => {
  const testId = props["data-testid"] ?? "vpc-skeleton";

  return (
    <div data-testid={testId}>
      <Container>
        <SkeletonMask faded display="inline-block">
          VPC network - loading VPC...
        </SkeletonMask>
      </Container>
      <Box display="block" mt={2}>
        <VPCNote />
      </Box>
    </div>
  );
};
